import { createSlice } from "@reduxjs/toolkit";
import config from "../../config";
import axios from "axios";

const GymCategorySlice = createSlice({
  name: "GymCategory",

  initialState: {
    categoryData: [],
    isLoading: true,
    isError: false,
  },

  reducers: {
    fetchCategoryStart: (state) => {
      state.isLoading = true;
      state.isError = false;
    },
    fetchCategorySuccess: (state, action) => {
      state.isLoading = false;
      state.categoryData = action.payload;
    },
    fetchCategoryFailure: (state, action) => {
      state.isLoading = false;
      state.isError = action.payload;
    },
  },
});

export const {
  fetchCategoryStart,
  fetchCategorySuccess,
  fetchCategoryFailure,
} = GymCategorySlice.actions;

export const fetchGymCategory = () => async (dispatch, getState) => {
  const { GymCategory } = getState();
  if (GymCategory.categoryData.length > 0) {
    return;
  }
  dispatch(fetchCategoryStart());

  try {
    const response = await axios.get(`${config.apiUrl}/home`);
    dispatch(fetchCategorySuccess(response.data.category_list || []));
  } catch (error) {
    dispatch(fetchCategoryFailure(error));
  }
};

export default GymCategorySlice.reducer;
